import { memo } from 'react';

import { widgetRegistry } from '@/features/_shared/widget-registry';

function isToolError(output: unknown): output is { error: string } {
  return !!output && typeof output === 'object' && 'error' in output;
}

const WidgetMapper = ({ toolName, output }: { toolName: string; output: unknown }) => {
  if (isToolError(output)) {
    return (
      <p className='text-sm text-destructive'>Couldn’t render this response: {output.error}</p>
    );
  }

  /* oxlint-disable react-hooks-js/static-components -- registry returns a stable registered component, not a new instance */
  const Widget = widgetRegistry.resolve<{ data: unknown }>(toolName);
  if (Widget) return <Widget data={output} />;
  /* oxlint-enable react-hooks-js/static-components */
  return null;
};

export default memo(WidgetMapper);
